import {
  AI2Logo
} from "./chunk-GYFBFKUL.js";
import {
  Content
} from "./chunk-WQQCTYOM.js";

// src/components/header/AI2Banner.tsx
import { Grid, styled } from "@mui/material";
import React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var BannerLink = styled("a")`
    display: inline-block;
    padding: 5px 0 2px 0;
`;
var BannerContent = styled(Content)`
    padding-top: 0;
    padding-bottom: 0;
`;
var StyledBanner = styled(({ grayscale, ...rest }) => /* @__PURE__ */ jsx("div", { ...rest }))`
    background: ${({ theme, grayscale }) => grayscale ? `black` : theme.paletteExtended.background.dark.hex};
    padding: ${({ theme }) => theme.spacing(0.5)} 0;
    line-height: 1;
`;
var AI2Banner = React.forwardRef(
  ({ children, logoSize, grayscale, endSlot, ...rest }, ref) => /* @__PURE__ */ jsx(StyledBanner, { grayscale, ref, ...rest, children: /* @__PURE__ */ jsx(BannerContent, { children: children || /* @__PURE__ */ jsxs(Grid, { container: true, justifyContent: "space-between", spacing: 2, children: [
    /* @__PURE__ */ jsx(Grid, { item: true, children: /* @__PURE__ */ jsx(BannerLink, { href: "https://allenai.org", children: /* @__PURE__ */ jsx(AI2Logo, { color: "white", size: logoSize || "sm" }) }) }),
    !!endSlot && /* @__PURE__ */ jsx(Grid, { item: true, children: endSlot })
  ] }) }) })
);
AI2Banner.displayName = "AI2Banner";

export {
  BannerLink,
  AI2Banner
};
//# sourceMappingURL=chunk-7WX3CAJ3.js.map